import * as angular from 'angular';
import * as d3 from 'd3';

import { ComponentDefinition } from '../../models';

class LineStyleDisplayController implements angular.IComponentController {
    lineStyle: string;
    previousLineStyle: string;

    static $inject = ['$element'];

    constructor(private _$element: angular.IRootElementService) {
    }

    $onInit() {
        if (this.lineStyle) {
            d3.select(this._$element[0])
                .select('line')
                .classed(this.lineStyle, true);
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['lineStyle'] && changesObj['lineStyle'].currentValue) {
            if (this.lineStyle) {
                d3.select(this._$element[0])
                    .select('line')
                    .classed(this.previousLineStyle, false)
                    .classed(this.lineStyle, true);
            } else {
                d3.select(this._$element[0])
                    .select('line')
                    .classed(this.previousLineStyle, false);
            }
            this.previousLineStyle = this.lineStyle;
        }
    }
}

export const wtLineStyleDisplay: ComponentDefinition = {
    componentId: 'wtLineStyleDisplay',
    controller: LineStyleDisplayController,
    template: require('./lineStyleDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        lineStyle: '<'
    }
};
